export default "__VITE_ASSET__f68f7c25__"